import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, Observable } from 'rxjs';
// import { AuthService } from '../app/auth-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InteractionLogService {
  private baseUrl = environment.API_URL + '/interactions';
  // private baseAPI = environment.API_URL;

  constructor(private http: HttpClient) {}

  allInteractions(params: any) {
    const url = `${this.baseUrl}/admin/getAll`;
    return this.http.get<any>(url, { params }).pipe(first());
  }

  saveInteractionLogComment(CommentDTO: any) {
    const url = `${this.baseUrl}/addComment`;
    return this.http.post<any>(url, CommentDTO).pipe(first());
  }

  saveInteraction(InteractionLogsDTO: any) {
    const url = `${this.baseUrl}/save`;
    return this.http.post<any>(url, InteractionLogsDTO).pipe(first());
  }

  getAgentReportSummary(from: string, to: string): Observable<any[]> {
    // return this.http.get<any[]>(`/report/agent-summary?from=${from}&to=${to}`);
    const url = `${this.baseUrl}/report/agent-summary?from=${from}&to=${to}`;
    return this.http.get<any>(url).pipe(first());
  }

  getDueDateReportSummary(from: string, to: string): Observable<any[]> {
    // return this.http.get<any[]>(`/report/agent-summary?from=${from}&to=${to}`);
    const url = `${this.baseUrl}/report/due-summary?startDate=${from}&endDate=${to}`;
    return this.http.get<any>(url).pipe(first());
  }

  getDueDateReportDetail(
    agentId: number,
    from: string,
    to: string
  ): Observable<any[]> {
    // return this.http.get<any[]>(`/report/agent-summary?from=${from}&to=${to}`);
    const url = `${this.baseUrl}/report/due-details?agentId=${agentId}&startDate=${from}&endDate=${to}`;
    return this.http.get<any>(url).pipe(first());
  }

  downloadExcel(from: string, to: string) {
    return this.http.get(`${this.baseUrl}/report/due-excel`, {
      params: {
        startDate: from,
        endDate: to,
      },
      responseType: 'blob', // 👈 Important for file download
    });
  }
}
